/**
 * Normalizes sihayplata://es/user/foo → /es/user/foo for react-router.
 */
export function normalizeCapacitorDeepLink(url: string): string {
    let s = url.trim();
    if (s.startsWith("sihayplata://")) {
        s = `/${s.slice("sihayplata://".length)}`;
    } else if (s.startsWith("sihayplata:")) {
        s = s.slice("sihayplata:".length).replace(/^\/\//, "/");
        if (!s.startsWith("/")) s = `/${s}`;
    }
    if (!s.startsWith("/")) s = `/${s}`;
    try {
        const u = new URL(s, "https://dummy.invalid");
        return `${u.pathname}${u.search}${u.hash}`;
    } catch {
        return s;
    }
}
